/* src/app/modules/expense-reports/components/district-data/district-data.component.scss */
.district-data-table th {
  width: 85%;
  vertical-align: middle;
}
.district-data-table td.answer-cell {
  width: 15%;
  min-width: 160px;
}
.district-data-table input,
.district-data-table select {
  width: 100%;
}
/*# sourceMappingURL=district-data.component.css.map */
